<template>
  <div class="creditos-especial mt-5">
		<div class="position-relative">
			<div class="row justify-content-center m-0 list-credits pt-3 pb-5">
				<div class="col-md-8 col-12 col-lg-8">
					<div class="credits text-center">					
						<h3 class="mt-5 mb-3">{{ $t('creditos.creditos_resenia') }}</h3>					
								
							
							<div class="mt-3">								

								<div class="text-center">
									<span class="title">{{ $t('creditos.reporteros') }}:</span>
									<div class="mb-3 nombre">
										{{ $t('creditos.reporteros_foco') }}
									</div>
								</div>
								<div class="text-center">
									<span class="title">{{ $t('creditos.editor') }}:</span>
									<div class="mb-3 nombre">
										{{ $t('creditos.editor_lista') }}
									</div>
								</div>
								<div class="text-center">
									<span class="title">{{ $t('creditos.video_edicion') }}:</span>
									<div class="mb-3 nombre">
										{{ $t('creditos.video_lista') }}
									</div>
								</div>
								<div class="text-center">
									<span class="title">{{ $t('creditos.desarrollo_web') }}:</span>
									<div class="mb-3 nombre">
										<span>{{ $t('creditos.desarrollo') }}</span>
									</div>
								</div>
								
							</div>					
					</div>
					<div class="creditos-support">
						<span>{{ $t('creditos.creditos_support') }}</span>
					</div>
				</div>
			</div>
	
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Creditos'
	}
</script>